// Layout.js
import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../../components/header/Header';
import './Layout.css';
import SearchBox from '../../components/searchBox/SearchBox';

const Layout = () => {
  return (
    <>
      <Header />
      {/* <SearchBox  /> */}
      <div className="layout-content">
        <Outlet />
      </div>
    </>
  );
};

export default Layout;
